<template>
  <div>
    <job-preview-right-column
      :text-count-mode="textCountMode"
      :highlight-mode="highlightMode"
      comment-class="main-article"
      :comment-highlights="commentHighlights"
      text-count-class="inner"
      :text-counts="textCounts"
      v-on="$listeners"
    />
    <section class="mlr10">
      <div class="fll mt5 intro-left">
        <h2
          :id="targetIdMap.mainArticle.title"
          class="fs15 fwB pega-pre-wrap"
          style="line-height: 1.6;"
          data-test="title"
          v-text="title"
        />
        <p
          :id="targetIdMap.mainArticle.body"
          class="fs13 mt15 pega-pre-wrap"
          data-test="body"
          v-text="body"
        />
      </div>
      <div class="flr intro-right">
        <figure>
          <img
            v-if="photoData"
            :id="targetIdMap.mainArticle.photo"
            :src="getPhotoUrl(photoData)"
            data-test="photo"
            @load="$emit('onLoadImage')"
            @error="$emit('onLoadImage')"
          >
          <figcaption
            v-if="caption"
            :id="targetIdMap.mainArticle.caption"
            class="fs11 pt10 pega-pre-wrap"
            data-test="caption"
            v-text="caption"
          />
        </figure>
        <job-appeal-point-pc :pr-codes="prCodes" />
      </div>
      <div class="clearfix" />
    </section>
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/preview/pc/offer/base" as *;
</style>

<script>
import JobPreviewRightColumn from '@/components/molecules/JobPreviewRightColumn'
import JobAppealPointPc from '@/components/molecules/JobAppealPointPc'
import jobPreviewCommon from '@/lib/jobPreviewCommon'
import jobPreviewHighlight from '@/lib/jobPreviewHighlight'

export default {
  components: {
    JobPreviewRightColumn,
    JobAppealPointPc
  },
  mixins: [jobPreviewCommon, jobPreviewHighlight],
  props: {
    title: {
      type: String,
      required: true
    },
    body: {
      type: String,
      required: true
    },
    photoData: {
      type: Object,
      default: null
    },
    caption: {
      type: String,
      default: ''
    },
    prCodes: {
      type: Array,
      default: () => []
    },
    commentHighlights: {
      type: Array,
      default: () => []
    },
    highlightMode: {
      type: Boolean,
      required: true
    },
    textCountMode: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    textCounts () {
      return [
        this.getTextCount('メインタイトル', this.title, this.targetIdMap.mainArticle.title),
        this.getTextCount('メイン記事', this.body, this.targetIdMap.mainArticle.body),
        this.getTextCount('メイン写真キャプション', this.caption, this.targetIdMap.mainArticle.caption)
      ]
    }
  }
}
</script>
